import { defer, LoaderFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import Score from '@models/Score'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type TemplateCopiesResponse = {
  scores: Score[]
  template: Score
  count: number
} & PaginatedResponse

export type TemplateLoaderResponse = {
  templateCopies: Promise<TemplateCopiesResponse>
  order: string | null
}

export const TEMPLATE_COPIES_PAGE_COUNT = 15

const templateLoader: LoaderFunction = async ({ params, request }) => {
  const { templateScoreId, ...query } = params
  const url = new URL(request.url)
  const order = url.searchParams.get('order')

  const templateCopies = http.loader.post(ApiRoutes.members.templateCopiesPath(), {
    template_id: templateScoreId,
    ...query,
    order,
    max_count: TEMPLATE_COPIES_PAGE_COUNT,
  })
  return defer({ templateCopies, order })
}

export default templateLoader
